import { Checkbox } from '@/components/ui/checkbox';
import { DistributorKind } from '@/types/auth/DistributorKind';
import { ColumnDef } from '@tanstack/react-table';
import { Translator } from '../translator.type';

export type Distributor = {
  companyId: string;
  agencyId: string;
  createdAt: string;
  updatedAt: string;
  shouldShareAllFutureCircuits: boolean;
  distributor: {
    name: string;
    city: string;
    country: string;
    kind: DistributorKind;
    network: {
      name: string;
    } | null;
  };
  _count: {
    circuits: number;
    distributed: number;
  };
  receiver: {
    _count: {
      Circuit: number;
    };
  };
};

export const DISTRIBUTOR_COLUMNS = (
  t: Translator,
): ColumnDef<Distributor>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'distributor.name',
    header: t('distributors.columns.name'),
  },
  {
    accessorKey: 'distributor.city',
    header: t('distributors.columns.city'),
  },
  {
    accessorKey: 'distributor.country',
    header: t('distributors.columns.country'),
  },
  {
    accessorKey: 'distributor.network.name',
    header: t('distributors.columns.network'),
    cell: ({ row }) => {
      const { distributor } = row.original;
      return (
        <span>
          {distributor.network?.name ??
            (distributor.kind === DistributorKind.TourOperator
              ? t('auth.profileSelector.tourOperator')
              : '—')}
        </span>
      );
    },
  },
  {
    accessorKey: '_count.circuits',
    header: t('distributors.columns.proposedCircuits'),
    cell: ({ row }) => (
      <span>{`${row.original._count.circuits}/${row.original.receiver._count.Circuit}`}</span>
    ),
  },
  {
    header: t('distributors.columns.distributedCircuits'),
    cell: ({ row }) => (
      <span>{`${row.original._count.distributed}/${row.original._count.circuits}`}</span>
    ),
    enableSorting: false,
  },
];
